import { Component, OnInit, Input } from '@angular/core';
import { ConfigurationService, HttpService } from '@sdbn/appclient';
import { TransportCreationProfile } from 'src/tmc-yard/client/model/station-usage.model';
import { environment } from 'src/environments/environment';
import { CRequestVehicleToStationByTransportCreationProfile as RequestVehicleToStationByTransportCreationProfile } from '../../model/action-tablet.model';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { ResponseMessage, ServiceResponse } from '@sdbn/appclient';
import { DialogService } from '@sdbn/common';

@Component({
  selector: 'app-action-tablet-transport-creation-profile-details',
  templateUrl: './action-tablet-transport-creation-profile-details.component.html',
  styleUrls: ['./action-tablet-transport-creation-profile-details.component.scss']
})
export class ActionTabletTransportCreationProfileDetailsComponent {

  isLoading = false;
  responseMessages: ResponseMessage[];

  @Input() stationId: number;
  @Input() transportCreationProfile: TransportCreationProfile;

  constructor(
    private httpService: HttpService,
    private tmcContextService: TmcContextService,
    public cps: ConfigurationService,
    private dialogService: DialogService
  ) { }

  public createPlannedTransportFromProfile() {
    if (this.isLoading) {
      return;
    }
    if (this.cps.isEnabled('clientproperty.station-tablet.transport-creation-profile.confirm-on-execute', false)) {
      this.dialogService.showConfirmWithTitleAndMessage('Wechselbrücke anfordern', 'Möchten Sie eine neue Wechselbrücke für den Prozess "' + this.transportCreationProfile.displayName + '" anfordern?')
      .afterClosed().subscribe(result => {
        if (result === true) {
          this.executeTransportCreationProfile();
        }
      });
    } else {
      this.executeTransportCreationProfile();
    }
    
  }

  private executeTransportCreationProfile() {
    const dto = new RequestVehicleToStationByTransportCreationProfile();
    dto.transportCreationProfileId = this.transportCreationProfile.id;
    dto.targetStationId = this.stationId;
    this.isLoading = true;
    this.httpService.postWithContext<ServiceResponse>(environment.actionTabletEndpoint + '/request-vehicle-by-transport-creation-profile', dto).subscribe(response => {
      this.responseMessages = response.responseMessages;
      this.tmcContextService.forceRefreshOfStationUsages();
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    });
  }
}
